import { useMemo } from 'react';
import { TimedBanner } from 'components/TimedBanner';
import { Alert } from 'components/TimedBanner/styledComponents';

interface PartSpecificMessagesProps {
  quotedPartNumbers: string[];
  partNumbersToMessage: Record<string, { message: string; startDate?: string; endDate?: string }>;
  type?: 'error' | 'warning' | 'info' | 'success';
  fixed?: boolean;
}

export const PartSpecificMessages = ({
  quotedPartNumbers,
  partNumbersToMessage,
  type = 'warning',
  fixed = false,
}: PartSpecificMessagesProps) => {
  const uniqueMessageConfigs = useMemo(() => {
    const configs = quotedPartNumbers
      .filter((partNumber) => partNumbersToMessage[partNumber])
      .map((partNumber) => partNumbersToMessage[partNumber]);

    return Array.from(new Set(configs));
  }, [quotedPartNumbers, partNumbersToMessage]);

  return uniqueMessageConfigs.map((config, index) =>
    config.endDate || config.startDate ? (
      <TimedBanner
        type={type}
        startDate={config.startDate}
        endDate={config.endDate}
        fixed={fixed}
        key={index}
        zIndex={1}
      >
        {config.message}
      </TimedBanner>
    ) : (
      <Alert type={type} fixed={fixed} key={index} zIndex={1}>
        {config.message}
      </Alert>
    )
  );
};
